export const DOMAIN =
  process.env.REACT_APP_ENV === 'development'
    ? 'https://sales-stack-web-staging.api.holofy.io'
    : process.env.REACT_APP_ENV === 'staging'
    ? 'https://sales-stack-web-staging.api.holofy.io'
    : 'https://sales-stack-web-production.api.holofy.io';

export const GOOGLE_CLIENT_ID =
  process.env.REACT_APP_ENV === 'production'
    ? process.env.REACT_APP_SSO_CLIENT_PRODUCTION
    : process.env.REACT_APP_SSO_CLIENT_STAGING;

export const SSLE = 'LEAD_ENGAGER';
export const SSAE = 'AUDIENCE_ENGAGER';
export const SSPC = 'PRO_CALLER';
export const SSSB = 'STACK_BUNDLE';
export const SSPE = 'PRO_EMAILER';
